import { Trash2 } from "lucide-react";
import { FilterComponentProps } from "./type";

export const FilterComponent: React.FC<FilterComponentProps> = ({ filter, onUpdate, onRemove }) => (
  <div className="flex items-center gap-3 p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
    <select
      value={filter.field}
      onChange={(e) => onUpdate({ ...filter, field: e.target.value })}
      className="px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 rounded focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
    >
      <option value="Age">Age</option>
      <option value="Location">Location</option>
      <option value="Device">Device</option>
      <option value="Engagement">Engagement</option>
    </select>

    <select
      value={filter.operator}
      onChange={(e) => onUpdate({ ...filter, operator: e.target.value })}
      className="px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 rounded focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
    >
      <option value="equals">equals</option>
      <option value="not equals">not equals</option>
      <option value="greater than">greater than</option>
      <option value="less than">less than</option>
      <option value="contains">contains</option>
    </select>

    <input
      type="text"
      placeholder="Value"
      value={filter.value}
      onChange={(e) => onUpdate({ ...filter, value: e.target.value })}
      className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 rounded focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
    />

    <button
      onClick={onRemove}
      className="p-2 text-gray-500 dark:text-gray-400 hover:text-red-500 transition-colors"
    >
      <Trash2 className="w-4 h-4" />
    </button>
  </div>
);
